import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
import useAdd from "../../api/useAdd";
import { useTenant } from "../../context/TenantContext";
import { useTranslation } from "react-i18next";

const EmployeeAdd = ({ open, onClose, token }) => {
  const { t } = useTranslation();
  const { handleAdd, loading, resetForm } = useAdd("shop/employees", token);
  const { shop } = useTenant();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [salary, setSalary] = useState("");
  const [age, setAge] = useState("");
  const [contractDate, setContractDate] = useState("");
  const [contractDurations, setContractDurations] = useState("");
  const [selectedShop, setSelectedShop] = useState("");

  useEffect(() => {
    setSelectedShop(shop?.id ? String(shop.id) : "");
  }, [shop?.id, open]);

  const shopId = selectedShop || String(shop?.id || "");

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("shop", shopId);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("contact", contact);
    formData.append("address", address);
    formData.append("salary", salary);
    formData.append("age", age);
    formData.append("contract_date", contractDate);
    formData.append("contract_durations", contractDurations);
    handleAdd(formData);
  };

  useEffect(() => {
    if (resetForm) {
      setName("");
      setEmail("");
      setContact("");
      setAddress("");
      setSalary("");
      setAge("");
      setContractDate("");
      setContractDurations("");
      setSelectedShop("");
      onClose();
    }
  }, [resetForm, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("employee.addEmployee")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            margin="dense"
            label={t("employee.name")}
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("employee.email")}
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("employee.contact")}
            fullWidth
            required
            value={contact}
            onChange={(e) => setContact(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("employee.address")}
            fullWidth
            required
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("employee.salary")}
            type="number"
            fullWidth
            required
            value={salary}
            onChange={(e) => setSalary(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("employee.age")}
            type="number"
            fullWidth
            required
            value={age}
            onChange={(e) => setAge(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("employee.contractDate")}
            type="date"
            fullWidth
            required
            value={contractDate}
            onChange={(e) => setContractDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            margin="dense"
            label={t("employee.contractDurations")}
            type="date"
            fullWidth
            required
            value={contractDurations}
            onChange={(e) => setContractDurations(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("employee.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={
            loading ||
            !shopId ||
            !name ||
            !email ||
            !contact ||
            !address ||
            !salary ||
            !age ||
            !contractDate ||
            !contractDurations
          }
          sx={{ minWidth: 100 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            t("employee.submit")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmployeeAdd;
